import { render, staticRenderFns } from "./DropdownSearchable.vue?vue&type=template&id=060ede0d&scoped=true"
import script from "./DropdownSearchable.vue?vue&type=script&lang=js"
export * from "./DropdownSearchable.vue?vue&type=script&lang=js"
import style0 from "./DropdownSearchable.vue?vue&type=style&index=0&id=060ede0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060ede0d",
  null
  
)

export default component.exports